import React, { useState } from "react";
import Styles from "./Element.module.css";
import Fileupload from "../../../../commons/Inputs/FileUpload/Fileupload";
import TextInput from "../../../../commons/Inputs/TextInput/TextInput";
import { ReactComponent as RemoveIcon } from "../../../../assets/images/Remove.svg";
import { Add, Remove } from "@mui/icons-material";

const DocumentDetails = ({ userData, handleData, handleProceed }) => {
  
  const [formData, setFormData] = useState({
    trading: userData.trading || "",
    membership: userData.membership || "",
    membershipUndertaking: userData.membershipUndertaking || "",
    payment: userData.payment || "",
    pan: userData.pan || "",
    tan: userData.tan || "",
    gst: userData.gst || "",
  });
  const [nocDetails, setNocDetails] = useState([]);
  const [otherText, setOtherText] = useState([]);

  const [errors, setErrors] = useState({});

  const validateFields = () => {
    const docErrors = {};

    const requiredFields = Object.entries(formData).filter(
      ([key]) => key !== "nocDetails" && key !== "otherText"
    );
    requiredFields.forEach(([key, value]) => {
      if (!value) {
        docErrors[key] = `${
          key.charAt(0).toUpperCase() + key.slice(1)
        } is required`;
      }
    });

    nocDetails.forEach((noc, index) => {
      if (!noc.details) docErrors[`details_${index}`] = "Details are required";
      if (!noc.documentId)
        docErrors[`documentId_${index}`] = "Document Id is required";
    });

    setErrors(docErrors);
    return Object.keys(docErrors).length === 0;
  };

  const handleFieldChange = (value) => {
    if (value?.id) {
      let field = value?.field;
      let id = value?.id;
      let fileName = value?.fileName;
      let data = {
        id: id,
        fileName: fileName,
      };
      setFormData((prev) => ({ ...prev, [field]: data }));
    }
  };
  const handleFieldChangeIndex = (value) => {
    if (value?.type === "NOC") {
      let index = value?.index;
      let field = value?.value?.field;
      let id = value?.value?.id;
      let fileName = value?.value?.fileName;
      let data = {
        id: id,
        fileName: fileName,
      };
      let newNocDetails = [...nocDetails];
      newNocDetails[index][field] = data;
      setNocDetails(newNocDetails);
    } else if (value?.type === "OTHERS") {
      let index = value?.index;
      let field = value?.value?.field;
      let id = value?.value?.id;
      let fileName = value?.value?.fileName;
      let data = {
        id: id,
        fileName: fileName,
      };
      let newOtherText = [...otherText];
      newOtherText[index][field] = data;
      setOtherText(newOtherText);
    }
  };

  const handleTextInputChange = (value) => {
    let index = value?.index;
    let field = value?.field;
    let data = value?.value;
    let selType = value?.selType;
    if (selType === "OTHERS") {
      let newOtherText = [...otherText];
      newOtherText[index][field] = data;
      setOtherText(newOtherText);
    } else {
      let newNocDetails = [...nocDetails];
      newNocDetails[index][field] = data;
      setNocDetails(newNocDetails);
    }
  };
  const handleAddNoc = () => {
    setNocDetails((prev) => {
      const newNocDetails = [...prev, { details: "", documentId: "" }];
      return [...newNocDetails];
    });
  };

  const handleAddOther = () => {
    setOtherText((prev) => {
      const newOtherText = [...prev, { details: "", documentId: "" }];
      return [...newOtherText];
    });
  };

  const handleRemoveNoc = (index) => {
    setNocDetails((prev) => prev.filter((_, i) => i !== index));
  };

  const handleRemoveOther = (index) => {
    setOtherText((prev) => prev.filter((_, i) => i !== index));
  };

  const handleContinue = (data) => {
    // if (!validateFields()) return;

    const documentMapping = {
      documentMappingId: null,
      companyId: userData?.companyId || null,
      consumerId: userData?.consumerId || null,
      generatorId: userData?.generatorId || null,
      panDocId: formData.pan?.id || null,
      tanDocId: formData.tan?.id || null,
      gstDocId: formData.gst?.id || null,
      membershipFormDocId: formData.membership?.id || null,
      undertakingDocId: formData.membershipUndertaking?.id || null,
      proofOfPaymentDocId: formData.payment?.id || null,
      tradingLicenseDocId: formData.trading?.id || null,
      nocDocs: nocDetails.map((noc) => ({
        docId: noc.documentId?.id || null,
        name: noc.details || "NA",
      })),
      otherFiles: otherText.map((other) => ({
        docId: other.documentId?.id || null,
        name: other.details || "NA",
      })),
    };

    const updatedFormData = {
      ...formData,
      documentMapping,
      noc: nocDetails.map((noc) => ({
        name: noc.details || "NA",
        docId: Number(noc.documentId?.id) || 0,
      })),
      others: otherText.map((other) => ({
        name: other.details || "NA",
        docId: Number(other.documentId?.id) || 0,
      })),
    };

    handleData("documentList", updatedFormData);
    handleProceed(data);
  };

  const renderFileUpload = (heading, field, example, type, ID) => (
    <Fileupload
      heading={heading}
      value={formData[field]}
      onChange={handleFieldChange}
      height="45"
      example={example}
      type={type}
      error={errors[field]}
      id={ID}
      field={field}
      accept=".pdf"
    />
  );

  const renderTextInput = (
    heading,
    field,
    example,
    type,
    ID,
    index,
    updateDetails,
    selType
  ) => (
    <TextInput
      heading={heading}
      value={updateDetails[index][field]}
      onChange={(value) =>
        handleTextInputChange({ value, field, index, selType })
      }
      example={example}
      type={type}
      height="45"
      error={errors[field]}
      id={ID}
    />
  );

  const renderFileUploadIndex = (
    heading,
    field,
    example,
    type,
    ID,
    index,
    updateDetails
  ) => (
    <Fileupload
      heading={heading}
      value={updateDetails[index][field]}
      onChange={(value) => handleFieldChangeIndex({ value, index, type })}
      height="45"
      example={example}
      type={type}
      id={ID}
      field={field}
      accept=".pdf"
    />
  );

  const renderNocDetails = () => (
    <>
      {nocDetails.map((_, index) => (
        <div className={Styles.layer3ElementsContainer} key={index}>
          <div>
            {renderFileUploadIndex(
              "Upload NOC",
              `documentId`,
              "Upload NOC (.pdf accepted)",
              "NOC",
              `${index}_noc`,
              index,
              nocDetails
            )}
          </div>
          <div>
            {renderTextInput(
              "NOC Details",
              `details`,
              "Enter Details",
              "text",
              `${index}_noc`,
              index,
              nocDetails,
              "NOC"
            )}
          </div>
          <div className={Styles.removeCont}>
            <div
              className={Styles.removeCont_elem}
              onClick={() => handleRemoveNoc(index)}
            >
              <RemoveIcon style={{ fontSize: "14px" }} />
            </div>
          </div>
        </div>
      ))}
    </>
  );

  const renderOtherDetails = () => (
    <>
      {otherText.map((_, index) => (
        <div className={Styles.layer3ElementsContainer} key={index}>
          <div>
            {renderFileUploadIndex(
              "Other Files",
              `documentId`,
              "Other Documents (.pdf accepted)",
              "OTHERS",
              `${index}_other`,
              index,
              otherText
            )}
          </div>
          <div>
            {renderTextInput(
              "Other Details",
              `details`,
              "Enter Other Details",
              "text",
              `${index}_other`,
              index,
              otherText,
              "OTHERS"
            )}
          </div>

          <div className={Styles.removeCont}>
            <div
              className={Styles.removeCont_elem}
              onClick={() => handleRemoveOther(index)}
            >
              <RemoveIcon style={{ fontSize: "14px" }} />
            </div>
          </div>
        </div>
      ))}
    </>
  );

  return (
    <div className={Styles.elementMain}>
      <div className={Styles.displayInputSection}>
        <div className={Styles.conterntHeader}>Company Documentation</div>
        <div className={Styles.detailsInpMainContainer}>
          <div className={Styles.layer3ElementsContainer}>
            {renderFileUpload(
              "Membership Form",
              "membership",
              "Upload form (.pdf)",
              "MEMBERSHIP_FORM",
              "membership"
            )}
            {renderFileUpload(
              "Membership Undertaking (Notarized)",
              "membershipUndertaking",
              "Upload Undertaking (.pdf)",
              "MEMBERSHIP_UNDERTAKING",
              "membershipUndertaking"
            )}
            {renderFileUpload(
              "Proof of Payment",
              "payment",
              "Upload Payment Proof (.pdf)",
              "PAYMENT",
              "payment"
            )}
          </div>
          <div className={Styles.layer3ElementsContainer}>
            {renderFileUpload(
              "PAN Card Copy",
              "pan",
              "Upload PAN (.pdf)",
              "PAN",
              "pan"
            )}
            {renderFileUpload(
              "TAN Card Copy",
              "tan",
              "Upload TAN (.pdf)",
              "TAN",
              "tan"
            )}
            {renderFileUpload(
              "GST Certificate Copy",
              "gst",
              "Upload GST (.pdf)",
              "GST",
              "gst"
            )}
          </div>
          {userData?.profile?.case === "trader" && (
            <div className={Styles.layer2ElementsContainer}>
              {renderFileUpload(
                "Valid Trading License Copy",
                "trading",
                "Upload Trading License (.pdf)",
                "TRADING_LICENSE",
                "trading"
              )}
            </div>
          )}

          <div className={Styles.subConterntHeader}>
            <span className={Styles.spanDocuments}>Company's NOC Clients</span>
            <div className={Styles.addMoreHeaderCont} onClick={handleAddNoc}>
              <Add style={{ fontSize: "14px" }} />
            </div>
          </div>
          <div className={Styles.divider}></div>
          {renderNocDetails()}

          <div className={Styles.subConterntHeader}>
            <span className={Styles.spanDocuments}>
              Company's Other Details
            </span>
            <div className={Styles.addMoreHeaderCont} onClick={handleAddOther}>
              <Add style={{ fontSize: "14px" }} />
            </div>
          </div>
          <div className={Styles.divider}></div>
          {renderOtherDetails()}
        </div>
      </div>
      <div className={Styles.buttonSection}>
        <div className={Styles.prevBtn} onClick={() => handleProceed("prev")}>
          Back
        </div>
        <div className={Styles.nextBtn} onClick={() => handleContinue("next")}>
          Next
        </div>
      </div>
    </div>
  );
};

export default DocumentDetails;
